import { render, staticRenderFns } from "./NavData.vue?vue&type=template&id=33e2244c&scoped=true&"
import script from "./NavData.vue?vue&type=script&lang=js&"
export * from "./NavData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2244c",
  null
  
)

export default component.exports